import React, { useEffect } from 'react';
import './MembershipModal.css';

// Shown to a signed-in visitor who isn't a member yet (fresh sign-up, or a
// sign-in while their request is still pending) to explain that approval is in
// progress. Dismissible; App gates how often it appears.
export default function MembershipModal({ onClose }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div className="membership-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="membership-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="membership-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <img src="/images/logo.png" alt="" className="membership-modal-logo" />
        <h2 id="membership-modal-title">Thanks for joining!</h2>
        <p>
          Please be patient while we review your membership request. You’ll receive an
          email once you’re approved.
        </p>
        <button className="btn-primary" type="button" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>
  );
}
